module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.campaignFilterLists,
      "label": "Campaign Filter",
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.campaignID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "campaignID", $$v)
      },
      expression: "filter.campaignID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": true,
      "height": 56,
      "label": "Filter by Handle",
      "outlined": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.setFilterItems.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter.handle),
      callback: function($$v) {
        _vm.$set(_vm.filter, "handle", $$v)
      },
      expression: "filter.handle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "name",
      "item-value": "id",
      "items": _vm.clientFilterLists,
      "outlined": true,
      "label": "Client",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.clientID),
      callback: function($$v) {
        _vm.$set(_vm.filter, "clientID", $$v)
      },
      expression: "filter.clientID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    ref: "submissionDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Submission Date",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "hide-details": "auto"
          },
          on: {
            "change": function($event) {
              return _vm.setFilterItems()
            }
          },
          model: {
            value: (_vm.filter.filterDate),
            callback: function($$v) {
              _vm.$set(_vm.filter, "filterDate", $$v)
            },
            expression: "filter.filterDate"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.submissionDatePicker),
      callback: function($$v) {
        _vm.submissionDatePicker = $$v
      },
      expression: "submissionDatePicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "range": ""
    },
    model: {
      value: (_vm.filter.filterDate),
      callback: function($$v) {
        _vm.$set(_vm.filter, "filterDate", $$v)
      },
      expression: "filter.filterDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelMonth()
      }
    }
  }, [_vm._v("\n                      Cancel\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchMonthOk()
      }
    }
  }, [_vm._v("\n                      OK\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "sm6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "hide-details": true,
      "item-text": "text",
      "item-value": "value",
      "items": _vm.submissionStates,
      "outlined": true,
      "label": "Status",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.setFilterItems
    },
    model: {
      value: (_vm.filter.status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status", $$v)
      },
      expression: "filter.status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2 primary",
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item.handle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('social-handle', {
          attrs: {
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "tiktokHandle": item.handle,
            "instagramHandle": item.handle
          }
        })]
      }
    }, {
      key: "item.submissionDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticStyle: {
            "min-width": "70px"
          }
        }, [_vm._v(_vm._s(_vm.utils.formatCustomDate(item.submissionDate, 'DD/MM/YYYY')))])]
      }
    }, {
      key: "item.stats",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('a', {
          attrs: {
            "href": '/posts/internal/all-posts?handle=' + item.handle + '&campaignID=' + item.campaignID,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.stats))])])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          staticClass: "secondary--text",
          attrs: {
            "color": "primary",
            "small": "",
            "to": '/posts/internal/all-posts?handle=' + item.handle + '&campaignID=' + item.campaignID
          }
        }, [_vm._v("\n                View Post "), _c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-magnify")])], 1)]
      }
    }], null, true)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ea9d7d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/DraftSubmissionReport.vue
// module id = 2250
// module chunks = 0